export const toggleScrollLock = (lock: boolean) => {
  if (typeof window !== 'undefined') {
    document.body.style.overflow = lock ? "hidden" : "visible"
  }
};